/* eslint-disable import/prefer-default-export */
import api from "./axios";

export const transformQuery = (query) => {
  const queryString = Object.keys(query)
    .map((key) => `${key}=${query[key]}`)
    .join("&");
  if (queryString.length === 0) {
    return "";
  } else {
    return `?${queryString}`;
  }
};

export async function getUsers(params) {
  let query = "";
  if (params) {
    query = transformQuery(params);
  }
  const response = await api.get(`/users${query}`);
  return response;
}

export async function getSpecificUsers(role) {
  const response = await api.get(`/users/${role}`);
  return response;
}

export async function getUser(userId) {
  const response = await api.get(`/users/${userId}`);
  return response;
}

export async function postUser(user) {
  const response = await api.post("/users", user);
  return response;
}

export async function deleteUser(userId) {
  const response = await api.delete(`/users/${userId}`);
  return response;
}

export async function putUser(user, userId) {
  const response = await api.put(`/users/${userId}`, user);
  return response;
}
